/**
 * Currency Constants
 * 
 * Centralized currency definitions and utilities
 */

import type { Currency, CurrencyInfo } from '../../types/currency';

export const CURRENCIES: Record<Currency, CurrencyInfo> = {
  BRL: {
    code: 'BRL',
    symbol: 'R$',
    name: 'Real Brasileiro',
    locale: 'pt-BR',
    decimalPlaces: 2,
  },
  USD: {
    code: 'USD',
    symbol: '$',
    name: 'Dólar Americano',
    locale: 'en-US',
    decimalPlaces: 2,
  },
  EUR: {
    code: 'EUR',
    symbol: '€',
    name: 'Euro',
    locale: 'de-DE',
    decimalPlaces: 2,
  },
  GBP: {
    code: 'GBP',
    symbol: '£',
    name: 'Libra Esterlina',
    locale: 'en-GB',
    decimalPlaces: 2,
  },
  JPY: {
    code: 'JPY',
    symbol: '¥',
    name: 'Iene Japonês',
    locale: 'ja-JP',
    decimalPlaces: 0,
  },
  ARS: {
    code: 'ARS',
    symbol: '$',
    name: 'Peso Argentino',
    locale: 'es-AR',
    decimalPlaces: 2,
  },
  CLP: {
    code: 'CLP',
    symbol: '$',
    name: 'Peso Chileno',
    locale: 'es-CL',
    decimalPlaces: 0,
  },
  MXN: {
    code: 'MXN',
    symbol: '$',
    name: 'Peso Mexicano',
    locale: 'es-MX',
    decimalPlaces: 2,
  },
  CAD: {
    code: 'CAD',
    symbol: 'C$',
    name: 'Dólar Canadense',
    locale: 'en-CA',
    decimalPlaces: 2,
  },
  AUD: {
    code: 'AUD',
    symbol: 'A$',
    name: 'Dólar Australiano',
    locale: 'en-AU',
    decimalPlaces: 2,
  },
};

export const DEFAULT_CURRENCY: Currency = 'BRL';

export const CURRENCY_LIST = Object.values(CURRENCIES);

export const CURRENCY_CODES = Object.keys(CURRENCIES) as Currency[];

/**
 * Get currency info by code
 */
export function getCurrencyInfo(code: Currency): CurrencyInfo {
  return CURRENCIES[code];
}

/**
 * Get currency symbol
 */
export function getCurrencySymbol(code: Currency): string {
  return CURRENCIES[code].symbol;
}

/**
 * Get currency name
 */
export function getCurrencyName(code: Currency): string {
  return CURRENCIES[code].name;
}

/**
 * Check if currency code is valid
 */
export function isValidCurrency(code: string): code is Currency {
  return code in CURRENCIES;
}
